/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=611c35e2"
const script = {}

import exportComponent from "D:\\HBuilderProjects\\quyizu-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__